'use client';

import './jumbotron-considerable.scss';

import { useTranslation } from 'react-i18next';

import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.js';
import { cn } from '@sola/ark-core/utils/helpers.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { FlexibleContentProps } from '@sola/schema/lib/schema.js';

import { Image } from '../../../atoms/image/image';
import { Video } from '../../../atoms/video/video';
import { FeatureBase } from '../../../molecules/feature-base/feature-base';
import {
  Lightbox,
  LightboxTrigger,
} from '../../../molecules/lightbox/lightbox';
import { getBaseSizeProps } from '../../../utils/text-utils';

export const JumbotronConsiderable: React.FC<FlexibleContentProps> = ({
  seoLevel = 2,
  media,
  alt,
  inline,
  items: _items,
  ...props
}) => {
  const { t } = useTranslation(['skippy']);

  return (
    <section
      className={cn(
        'JumbotronConsiderable component--container relative flex items-center justify-center',
        {
          'JumbotronConsiderable--alt': alt,
          component: !inline,
        },
      )}
    >
      <div className="JumbotronConsiderable__media absolute top-0 left-0 bottom-0 right-0">
        {media && media.image && !media.video && (
          <Image
            className="JumbotronConsiderable__media-img"
            image={media.image}
            priority={seoLevel === 1}
            sizeIntent="full"
          />
        )}
        {media && media.video && (
          <Video {...media.video} poster={media.image} isBackground />
        )}
        {media && (media.image || media.video) && (
          <div className="JumbotronConsiderable__overlay absolute top-0 left-0 bottom-0 right-0" />
        )}
      </div>

      <div className="JumbotronConsiderable__container relative w-full max-w-xl mx-auto flex flex-col justify-center items-center">
        <FeatureBase
          {...props}
          {...getBaseSizeProps(1)}
          seoLevel={seoLevel}
          className="w-full max-w-md mx-auto"
          buttonVariant="grow"
          alignment="center"
          variant="centered"
          variantResponsive
          inline
          programmaticButtons={
            media?.video && media.video.hasProgrammaticButton ? (
              <Lightbox
                key="jumbotron-considerable-lightbox"
                items={[
                  {
                    media,
                  },
                ]}
                startIndex={0}
              >
                <LightboxTrigger className="flex">
                  <ButtonStyle
                    iconBefore={<ArkIcon iconName="play-circle" />}
                    variant={props.secondaryCTA ? 'tertiary' : 'secondary'}
                  >
                    <span>{t('skippy:video.watch')}</span>
                  </ButtonStyle>
                </LightboxTrigger>
              </Lightbox>
            ) : undefined
          }
        />
      </div>
    </section>
  );
};
